import React from "react";
import {
  getActiveRegistrationSteps,
  getProgressDisplayStep,
} from "../registration/registrationModules";

export const ProgressBar = ({
  step,
  abstractStepNumber,
  hidePostSummarySteps,
}) => {
  const steps = getActiveRegistrationSteps(abstractStepNumber).filter(
    (flowStep) => !hidePostSummarySteps || flowStep.step <= 6
  );
  const displayStep = getProgressDisplayStep(step, abstractStepNumber);

  return (
    <div className="progress-bar">
      {steps.map(({ label, step: flowStep }, i) => {
        const status =
          displayStep === flowStep
            ? "current"
            : displayStep > flowStep
            ? "done"
            : "upcoming";

        return (
          <div key={i} className={`progress-step ${status}`}>
            <div className="progress-circle">{flowStep}</div>
            <div className="progress-label">{label}</div>
          </div>
        );
      })}
    </div>
  );
};
